export const environment = {
  production: true,
  apiBaseUrl: 'https://democore.files.fi/api/v1/',
  apiKey: '2b55f40c0e82925e8e336d250f9545b690ad09363bc001704fd1609b5b1130d0',
  clientId: 'cVFRO4rGxXFVWE0rQ9FP',
  froalaLicence: 'bA2A6A6B7C5A2A-9H3E2J2A4C6C3D4B5F2C1pBKBOb1a1PQd1ERGRe1B==',
  locales: ['en', 'fi']
};
